import prevBindFn from '../../../../handlers/StudentPresentation/openPresentation.js';

export default (props, vars) =>
  typeof prevBindFn === 'function' ? prevBindFn(props, vars) : prevBindFn;
